<section id="content" class="qualified-teacher" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.qualifiedTeachers }}
      </h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a>{{ lang.qualifiedTeachers }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="listTab">
                    <div class="row p-10">

                      <div class="col-sm-2">
                        <div class="social-icons">

                          <a class="plus-add" [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_CREATE]" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                            <i class="fa fa-plus"></i>
                          </a>

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4" title="Export"> 
                            <span class="glyphicon glyphicon-export"></span>
                          </a>

                          <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show"
                            data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                            <span class="glyphicon glyphicon-import"></span>
                          </a>

                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" 
                          [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Delete">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>
                      </div>

                      <div  class="col-sm-10">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>   

                  
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1" *ngIf="qualified_data">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>{{ lang.sno }}</th>
                            <th>{{ lang.name }}</th>
                            <th>{{ lang.surname }}</th>
                            <th>{{ lang.telephone }}</th>
                            <th>{{ lang.email }}</th>
                            <th>{{ lang.company }}</th>
                            <th>{{ lang.skills }}</th>
                            <th>{{ lang.qualificationDate }}</th>
                            <th>{{ lang.qualificationStatus }}</th>
                            <th>{{ lang.action }}</th>
                          </tr>
                        </thead>
                        <tbody dragula="qualified_data" [(dragulaModel)]="qualified_data">
                          <tr *ngFor="let record of qualified_data let i = index" id="{{record.qualified_teacheId}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{ record.fname }}</td>
                            <td><a [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_VIEW+'/'+record.qualified_teacheId]">{{ record.lname }}</a></td>
                            <td>{{ record.telephone }}</td>
                            <td>{{ record.email }}</td>
                            <td>{{ record.company }}</td>
                            <td><div [innerHTML]="record.skil"></div></td>
                            <td><div [innerHTML]="record.qual_date"></div></td>
                            <td></td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.qualified_teacheId)"><i
                                    class="fa fa-trash"></i> {{ lang.erase  }}</a></li>

                                    <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a  [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_EDIT+'/'+record.qualified_teacheId]"  class="edit_action"><i
                                      class="fa fa-edit"></i> {{ lang.modify  }}</a></li>

                                
                                  <li><a [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER_VIEW+'/'+record.qualified_teacheId]"
                                      class="view_action"><i class="glyphicon glyphicon-eye-open"></i>{{ lang.view }}</a>
                                  </li>
                                </ul>
                              </div>
                            </td>

                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>


                </div>

              </div>



              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-servicing-calendar></app-servicing-calendar>
              </div>



            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}
        </h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }}
            </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}
            </h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>


<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- <div class="modal-header">
          <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
          <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>      
        </div>
         -->

      <div class="modal-header">
        <h4 class="modal-title pull-left uppercase">{{ lang?.importTitle }}
        </h4>
        <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <div class="modal-body column_export">
        <div class="row">
          <form>
            <input type="file" class="filestyle" id="file" name='file' data-buttonText="Choose file"
              (change)="onPhotoPickerChange($event)" appFileDesign>
            <font style="vertical-align: inherit;">
              <font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_qualified_teachers.csv" download="">{{ lang?.clickhere }}</a> </font>
            </font>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <!-- <div id="datatableExportBtn2" class="export_dynamic_btn">
          </div> -->
        <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport3" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ mLang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export2_select_deselect_all($event)"><i></i> {{ mLang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ mLang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols2">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
<script type="text/javascript">

</script>